import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.query<GetByeMatchesTeamsReponse, GetByeMatchesTeamsParams>({
    query: ({ tournamentId, categoryId }) => ({
      url: `/v4/pitch-owner/tournaments/${tournamentId}/custom/${categoryId}/team/bye-matches`,
    }),
  });

export type GetByeMatchesTeamsParams = {
  tournamentId: number;
  categoryId: number;
};

export type GetByeMatchesTeamsReponse = {
  data: ByeMatchTeam[];
};

export type ByeMatchTeam = {
  match_id: number;
  team_id: number;
  players: string[];
};
